import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import './FAQ.css';
import usePageSearchIndex from '../hooks/usePageSearchIndex';

const FAQ = () => {
  const { isMarathi } = useLanguage();
  const [openItems, setOpenItems] = useState({});
  const navigate = useNavigate();

  const faqData = {
    marathi: {
      title: 'सामान्य प्रश्न',
      description: 'महाराष्ट्र कामगार कल्याण मंडळाशी संबंधित सामान्य प्रश्न आणि उत्तरे',
      lastUpdated: 'शेवटचे अपडेट: 16 सप्टेंबर 2025',
      faqs: [
        {
          question: 'महाराष्ट्र कामगार कल्याण निधी अधिनियम १९५३ कोणाला लागू आहे ?',
          answer: 'मुंबई दुकाने आणि आस्थापना अधिनियम १९४८, कारखाने अधिनियम १९६१, मोटार वाहतूक कामगार कायदा १९४८ या तीन कायद्याअंतर्गत नोंदणी झालेल्या आणि ज्यात किमान ५ कामगार आहेत, अशा सर्व आस्थापनांना हा कायदा लागू आहे. यात विविध कंपन्या, आस्थापना, कारखाने, टूर्स आणि ट्रॅव्हल्स एजन्सी, बँका आदींचा समावेश होतो.'
        },
        {
          question: 'या अधिनियमानुसार कामगार म्हणजे कोण ?',
          answer: 'कामगार / कर्मचारी म्हणजे एखाद्या व्यापारी संस्थेत कोणतेही काम करण्यासाठी, मग ते कुशल असो किंवा अकुशल असो, (अंगमेहनतीचे, कारकुनी, पर्यवेक्षकीय किंवा तांत्रिक असो) मजुरीने किंवा बक्षिस देऊन कामावर लावलेली कोणतीही व्यक्ती यात मोडते. तथापी, व्यवस्थापकीय किंवा पर्यवेक्षकीय (रु.२५००/- पेक्षा अधिक वेतन असणारी व्यक्ती) स्वरुपाची कामे करीत असलेल्या व्यक्तींचा यात समावेथ होत नाही.'
        },
        {
          question: 'महाराष्ट्र कामगार कल्याण निधी म्हणजे काय ?',
          answer: 'कामगारांचा दर ६ महिन्यांनी जून आणि डिसेंबरमध्ये मंडळाकडे निधी भरणे बंधनकारक आहे. दरमहा रु.३०००/- पेक्षा जास्त पगार घेणाऱ्या सर्व कामगार / कर्मचाऱ्यांच्या वेतनातून रु.१२/- कपात केले जातात. सोबत प्रत्येक कामगारामागे मालकाने रु.३६/- जमा करावयाचे असतात. आणि राज्यशासनाने प्रत्येक कामगारामागे रु.२४/- मंडळाकडे जमा करावयाचे असतात. या निधीतून कामगार आणि त्यांच्या कुटुंबियांसाठी कल्याणकारी योजना राबविल्या जातात.'
        },
        {
          question: 'आस्थापना / कंपनी यांनी मंडळाकडे नोंदणी करुन घेण्याची प्रक्रिया काय आहे ?',
          answer: 'नवीन आस्थापना नोंदणीसाठी मंडळाच्या संकेतस्थळावर तसेच मध्यवर्ती कार्यालय, मुंबई येथे फॉर्म उपलब्ध आहे. मंडळाकडे फॉर्म जमा करावा. त्यानंतर संबंधित आस्थापनेची नोंदणी करुन एक कायमस्वरुपी कोड नंबर दिला जातो.'
        },
        {
          question: 'कामगार कल्याण केंद्राच्या वेळा काय आहेत ?',
          answer: 'सकाळी ८ ते सायंकाळी ८.३० ही कामगार कल्याण केंद्रांची वेळ आहे. त्यातील सकाळी ११ ते सायंकाळी ५ ही वेळ महिला व मुलांच्या उपक्रमांसाठी राखीव असते. सार्वजनिक सुट्टी, दुसरा व चौथा शनिवार तसेच सर्व रविवार ही केंद्र बंद असतात.'
        },
        {
          question: 'मंडळाच्या योजना, उपक्रम व कार्यक्रमांचा लाभ घेण्यासाठी कुठे संपर्क साधावा ?',
          answer: 'ज्या व्यक्तिंना मंडळाच्या योजना, उपक्रम व कार्यक्रमांचा लाभ घ्यावयाचा आहे त्यांनी नजीकच्या कामगार कल्याण केंद्राशी संपर्क साधावा. या केंद्रात सभासद फॉर्म व संबंधित योजना/उपक्रमाचा भरुन लाभ घेता येतो.'
        },
        {
          question: 'एका योजनेचा लाभ घेतल्यानंतर त्याच व्यक्तिला दुसऱ्या योजनेचे लाभ घेता येतो काय ?',
          answer: 'आवश्यक नियम-अटींची पुर्तता करत असल्यास लाभ घेता येतो.'
        },
        {
          question: 'मंडळाच्या विविध कार्यक्रमांचे वेळापत्रक आहे काय ?',
          answer: 'मंडळाच्या कार्यक्रमांची कालबद्ध सूची तयार करण्यात आली आहे. तथपी, वेळापत्रकाबाबत नजीकच्या कामगार कल्याण केंद्र व कार्यालयाशी संपर्क साधावा.'
        },
        {
          question: 'गंभीर आजार उपचार सहाय्यता योजनेचा लाभ कुणाला मिळतो ?',
          answer: 'कामगार आणि त्यांच्या कुटुंबियांना या योजनेचा लाभ घेता येतो. कर्करोग, हृदयरोग, मूत्रपिंड, एड्स तसेच इतरही अनेक गंभीर आजाराच्या उपचारासाठी ही मदत मिळते. रुग्णाला आधी स्वत: खर्च करावा लागतो. त्यानंतर एक वर्षाच्या आत मंडळाकडे आवश्यक कागदपत्रांसह सदर योजनेअंतर्गत अर्ज करता येतो. खर्चाचे स्वरूप पाहून जास्तीत-जास्त २५,०००/- पर्यंत अर्थसहाय्य मिळू शकते.'
        },
        {
          question: 'सर्वसाधारण शिष्यवृत्ती योजनेचा लाभ कुणाला मिळतो ?',
          answer: 'कामगार पाल्यांना इयत्ता नववी पास झाल्यानंतर पुढील सर्व शिक्षणासाठी सर्वसाधारण शिष्यवृत्ती योजनेसाठी अर्ज करता येतो. मागील वर्षी किमान ६० टक्के गुण मिळणे आवश्यक असून पुढील शिक्षण सुरु असावे.'
        },
        {
          question: 'पाठ्यपुस्तक सहायता योजना म्हणजे काय ?',
          answer: 'इयत्ता ११ वी पासून पुढील सर्व शिक्षणासाठी ही योजना आहे. यात कामगार पाल्यांना क्रमिक पाठ्यपुस्तके खरेदीच्या ५० टक्के रक्कम अनुदान दिले जाते. गाईड व इतर संदर्भपुस्तक खरेदीसाठी अनुदान दिले जात नाही.'
        },
        {
          question: 'गुणवंत कामगार कल्याण पुरस्कार कुणाला दिला जातो ?',
          answer: 'सामाजिक, शैक्षणिक, क्रीडा, संघटन आदी क्षेत्रात उल्लेखनिय काम केलेल्या कामगारांस या पुरस्काराने गौरविले जाते. रु.१५,०००/-, स्मृतीचिन्ह आणि मानपत्र असे या पुरस्काराचे स्वरूप आहे. सदर कर्मचारी / कामगाराची किमान ५ वर्ष नोकरी झालेली असावी.'
        },
        {
          question: 'कामगार भूषण पुरस्कारासाठी कधी अर्ज करता येतो ?',
          answer: 'गुणवंत कामगार कल्याण पुरस्कार मिळाल्याच्या १० वर्षांनी या पुरस्कारासाठी अर्ज करता येतो.'
        }
      ]
    },
    english: {
      title: 'Frequently Asked Questions',
      description: 'Common questions and answers related to Maharashtra Labour Welfare Board',
      lastUpdated: 'Last Updated: September 16, 2025',
      faqs: [
        {
          question: 'Who does the Maharashtra Labour Welfare Fund Act 1953 apply to?',
          answer: 'This act applies to all establishments registered under the Mumbai Shops and Establishments Act 1948, Factories Act 1961, and Motor Transport Workers Act 1948, which have a minimum of 5 workers. This includes various companies, establishments, factories, tours and travel agencies, banks, etc.'
        },
        {
          question: 'Who is considered a worker under this act?',
          answer: 'A worker/employee means any person employed for any work in a commercial establishment, whether skilled or unskilled (manual, clerical, supervisory or technical), employed for wages or salary. However, persons employed in managerial or supervisory capacity (earning more than Rs. 2500/-) are not included.'
        },
        {
          question: 'What is the Maharashtra Labour Welfare Fund?',
          answer: 'It is mandatory for workers to contribute to the fund every 6 months in June and December. Rs. 12/- is deducted from the salary of all workers/employees earning more than Rs. 3000/- per month. Additionally, employers must contribute Rs. 36/- per worker, and the state government contributes Rs. 24/- per worker to the board. Welfare schemes for workers and their families are implemented from this fund.'
        },
        {
          question: 'What is the registration process for establishments/companies with the board?',
          answer: 'For new establishment registration, forms are available on the board\'s website and at the central office in Mumbai. Submit the form to the board. After that, the concerned establishment is registered and a permanent code number is issued.'
        },
        {
          question: 'What are the timings of Labour Welfare Centres?',
          answer: 'Labour Welfare Centres are open from 8:00 AM to 8:30 PM. The time from 11:00 AM to 5:00 PM is reserved for women and children\'s programs. Centres are closed on public holidays, second and fourth Saturdays, and all Sundays.'
        },
        {
          question: 'Where to contact for availing benefits of board\'s schemes, programs and activities?',
          answer: 'Persons who want to avail benefits of the board\'s schemes, programs and activities should contact the nearest Labour Welfare Centre. At these centres, member forms and related scheme/program forms can be filled to avail benefits.'
        },
        {
          question: 'Can a person avail benefits of another scheme after availing one scheme?',
          answer: 'Yes, benefits can be availed if the necessary rules and conditions are fulfilled.'
        },
        {
          question: 'Is there a schedule for various programs of the board?',
          answer: 'A time-bound list of board programs has been prepared. However, for schedule details, contact the nearest Labour Welfare Centre and office.'
        },
        {
          question: 'Who gets benefits under the Serious Illness Treatment Assistance Scheme?',
          answer: 'Workers and their family members can avail benefits under this scheme. Assistance is provided for treatment of cancer, heart disease, kidney disease, AIDS and many other serious illnesses. The patient has to bear the expenses first. After that, within one year, an application can be made to the board with necessary documents under this scheme. Based on the nature of expenses, financial assistance up to a maximum of Rs. 25,000/- can be provided.'
        },
        {
          question: 'Who gets benefits under the General Scholarship Scheme?',
          answer: 'Children of workers can apply for the General Scholarship Scheme for all further education after passing Class 9. It is necessary to have obtained at least 60% marks in the previous year and the further education should be ongoing.'
        },
        {
          question: 'What is the Textbook Assistance Scheme?',
          answer: 'This scheme is for all education from Class 11 onwards. Under this, 50% of the amount for purchasing prescribed textbooks is provided as grant to children of workers. Grants are not provided for purchasing guides and other reference books.'
        },
        {
          question: 'Who is given the Meritorious Labour Welfare Award?',
          answer: 'Workers who have done remarkable work in social, educational, sports, organizational fields are honored with this award. The award consists of Rs. 15,000/-, memento and certificate. The concerned employee/worker should have a minimum of 5 years of service.'
        },
        {
          question: 'When can one apply for the Labour Bhushan Award?',
          answer: 'One can apply for this award 10 years after receiving the Meritorious Labour Welfare Award.'
        }
      ]
    }
  };

  const content = isMarathi() ? faqData.marathi : faqData.english;

  useEffect(() => {
    // Reserved for future non-search side effects if needed
  }, []);

  // Auto-index FAQ content for search
  usePageSearchIndex({
    mr: ['वारंवार विचारले जाणारे प्रश्न', 'प्रश्न', 'उत्तरे', 'सहाय्य', 'मदत', 'संपर्क'],
    en: ['faq', 'questions', 'answers', 'help', 'support', 'contact']
  });

  const pageHeaderData = {
    title: {
      marathi: content.title,
      english: content.title
    },
    subtitle: {
      marathi: content.description,
      english: content.description
    }
  };

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleFeedbackClick = () => {
    navigate('/feedback');
  };

  return (
    <div className="faq-page">
      <div className="faq-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        <div className="faq-content" data-read-section="faq-content">
          {content.faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openItems[index] ? 'open' : ''}`}
                onClick={() => toggleItem(index)}
                aria-expanded={openItems[index]}
              >
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">
                  {openItems[index] ? '−' : '+'}
                </span>
              </button>
              <div className={`faq-answer ${openItems[index] ? 'open' : ''}`}>
                <div className="faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p className="faq-note" onClick={handleFeedbackClick}>
            {isMarathi() 
              ? 'आपल्याला इतर प्रश्न असल्यास, कृपया आमच्याशी संपर्क साधा.'
              : 'If you have other questions, please contact us.'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
